import statuses from '@/helpers/statuses'

const initialState = () => ({
  keyMetrics: {},
  expertise: {},
  workStandards: {},
  mostEncouraging: {},

  meta: {
    loadingkeyMetrics: statuses.IDLE,
    loadingExpertise: statuses.IDLE,
    loadingWorkStandards: statuses.IDLE,
    loadingMostEncouraging: statuses.IDLE
  }
})

export default api => ({
  state: initialState,

  getters: {
    keyMetrics: state => teamId => state.keyMetrics[teamId],
    loadingKeyMetrics: state => state.meta.loadingkeyMetrics,
    isLoadingKeyMetrics: state => state.meta.loadingkeyMetrics === statuses.LOADING,

    expertise: state => teamId => state.expertise[teamId],
    loadingExpertise: state => state.meta.loadingExpertise,
    isLoadingExpertise: state => state.meta.loadingExpertise === statuses.LOADING,

    workStandards: state => teamId => state.workStandards[teamId],
    loadingWorkStandards: state => state.meta.loadingWorkStandards,
    isLoadingWorkStandards: state => state.meta.loadingWorkStandards === statuses.LOADING,

    mostEncouraging: state => teamId => state.mostEncouraging[teamId],
    loadingMostEncouraging: state => state.meta.loadingMostEncouraging,
    isLoadingMostEncouraging: state => state.meta.loadingMostEncouraging === statuses.LOADING
  },

  mutations: {
    fetchTeamMetrics: state => {
      state.meta.loadingkeyMetrics = statuses.LOADING
    },

    fetchTeamMetricsSuccess: (state, payload) => {
      state.meta.loadingkeyMetrics = statuses.LOADED
      state.keyMetrics = { ...state.keyMetrics, [payload.id]: payload.data }
    },

    fetchTeamMetricsFailure: (state, error) => {
      state.meta.loadingkeyMetrics = statuses.FAILED
    },

    fetchTeamExpertise: state => {
      state.meta.loadingExpertise = statuses.LOADING
    },

    fetchTeamExpertiseSuccess: (state, payload) => {
      state.meta.loadingExpertise = statuses.LOADED
      state.expertise = { ...state.expertise, [payload.id]: payload.data }
    },

    fetchTeamExpertiseFailure: (state, error) => {
      state.meta.loadingExpertise = statuses.FAILED
    },

    fetchTeamWorkStandards: state => {
      state.meta.loadingWorkStandards = statuses.LOADING
    },

    fetchTeamWorkStandardsSuccess: (state, payload) => {
      state.meta.loadingWorkStandards = statuses.LOADED
      state.workStandards = { ...state.workStandards, [payload.id]: payload.data }
    },

    fetchTeamWorkStandardsFailure: (state, error) => {
      state.meta.loadingWorkStandards = statuses.FAILED
    },

    fetchTeamMostEncouraging: state => {
      state.meta.loadingMostEncouraging = statuses.LOADING
    },

    fetchTeamMostEncouragingSuccess: (state, payload) => {
      state.meta.loadingMostEncouraging = statuses.LOADED
      state.mostEncouraging = { ...state.mostEncouraging, [payload.id]: payload.data }
    },

    fetchTeamMostEncouragingFailure: (state, error) => {
      state.meta.loadingMostEncouraging = statuses.FAILED
    },

    resetDashboard: state => {
      const payload = initialState()
      Object.keys(payload).forEach(key => {
        state[key] = payload[key]
      })
    }
  },

  actions: {
    fetchTeamMetrics: async ({ commit }, { teamId, timespan }) => {
      const slug = api.getWorkspaceSlug()
      commit('fetchTeamMetrics')
      try {
        const data = await api.fetchTeamMetrics(slug, teamId, timespan)
        commit('fetchTeamMetricsSuccess', { id: teamId, data })
      } catch (error) {
        commit('fetchTeamMetricsFailure', error)
      }
    },

    fetchTeamExpertise: async ({ commit }, { teamId, timespan }) => {
      const slug = api.getWorkspaceSlug()
      commit('fetchTeamExpertise')
      try {
        const data = await api.fetchTeamExpertise(slug, teamId, timespan)
        commit('fetchTeamExpertiseSuccess', { id: teamId, data })
      } catch (error) {
        commit('fetchTeamExpertiseFailure', error)
      }
    },

    fetchTeamWorkStandards: async ({ commit }, { teamId, timespan }) => {
      const slug = api.getWorkspaceSlug()
      commit('fetchTeamWorkStandards')
      try {
        const data = await api.fetchTeamWorkStandards(slug, teamId, timespan)
        commit('fetchTeamWorkStandardsSuccess', { id: teamId, data })
      } catch (error) {
        commit('fetchTeamWorkStandardsFailure', error)
      }
    },

    fetchTeamMostEncouraging: async ({ commit }, { teamId, timespan }) => {
      const slug = api.getWorkspaceSlug()
      commit('fetchTeamMostEncouraging')
      try {
        const data = await api.fetchTeamMostEncouraging(slug, teamId, timespan)
        commit('fetchTeamMostEncouragingSuccess', { id: teamId, data })
      } catch (error) {
        commit('fetchTeamMostEncouragingFailure', error)
      }
    },

    clear: ({ commit }) => {
      commit('resetDashboard')
    }
  }
})
